import { combineReducers } from "redux";
import blogPosts from "../modules/blog/reducer";
import evaluation from "../modules/evaluation/reducer";
import results from "../modules/results/reducer";
import user from "../modules/user/reducer";
import preference from "../modules/preference/reducer";
import pdf from "../modules/pdf/reducer";
import emails from "../modules/emails/reducer";

const rootReducer = combineReducers({
  // short hand property names
  blogPosts,
  evaluation,
  results,
  user,
  preference,
  pdf,
  emails
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js